export function PageHeader({ eyebrow, title, description, action }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8 pb-5 border-b border-line">
      <div className="min-w-0">
        {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
        <h1 className="font-display text-display-md text-ink">{title}</h1>
        {description && <p className="text-ink-2 mt-2 text-sm md:text-base max-w-xl">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
